import * as React from 'react'
import {connect} from "react-redux"
import {ApplicationState} from "../../store"
import {Button} from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import {actionDepartmentsSave, actionDepartmentsFetch} from "../../store/departments/actions"
import {actionActiveTabTitle} from '../../store/tabs/actions'
import {Tab} from '../Tab'
import {Validator} from '../../core/Validator'
import {DepartmentsDescriptor} from '../../models/Department'
import {Utility} from '../../core/Utility'
import {t} from "../../core/localization"
import {Department} from "../../models/Department"
import {departmentFieldsDescriptor} from "./DepartmentFields"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {LookupDataRow} from "../../services/LookupDataRow"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {FieldView} from "../components/FieldView"

export interface DepartmentsTabProps extends BaseTabProps{
	tab: Tab
	departments: Department[]
}

export interface DepartmentsTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		departments: state.departments.list
	}
}

class DepartmentsTab extends BaseTab<DepartmentsTabProps, DepartmentsTabState> {

	constructor(props: DepartmentsTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
    }

	componentWillMount() {

		if (this.props.item.id)
			actionDepartmentsFetch(this.props.item)
	}

	componentWillReceiveProps(nextProps: DepartmentsTabProps) {
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
				{this.renderControls()}
			</div>
		)
	}

	renderForm(): React.ReactNode {
		let descriptor: EntityFieldsDescriptor<any> = departmentFieldsDescriptor

		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
									lookupData={this.getLookupData.bind(this)}
								/>}
							</div>
						)
						}
				)
			}
		</div>
		)
	}

	getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		if(lookupEntity == LookupEntities.Departments) return this.props.departments.map((department: Department) => {return {label: department.title, value: department.id}})
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()
		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, DepartmentsDescriptor)

		if (validation.valid) {
			actionDepartmentsSave(itemToSave)
			actionActiveTabTitle(t.Department + ': ' + this.getItemFromTabState('title'))
		}
		this.setState({ ...this.state, validation: validation })
	}

}

export default connect(mapStateToProps)(DepartmentsTab)
